module.exports = __webpack_public_path__ + "img/11-1_02.1da98ceb.jpg";